<template>
    <div class="min-h-screen bg-white">
        <maintenance-notice-modal />
        <tos-reacceptance-modal />
        <slot />
    </div>
</template>

<script setup>
import MaintenanceNoticeModal from '@/Shared/MaintenanceNoticeModal.vue';
import TosReacceptanceModal from '@/Shared/TosReacceptanceModal.vue';
// Simple guest layout with white background
// No navigation, no header, just a clean white background
</script>
